import { render, staticRenderFns } from "./CardDetailsBuyer.vue?vue&type=template&id=48c3eb7c&"
import script from "./CardDetailsBuyer.vue?vue&type=script&lang=js&"
export * from "./CardDetailsBuyer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports